<template>
	<div v-if="question.image" class="mb-3">
		<dynamic-image :image="question.image"></dynamic-image>
	</div>

	<p class="question-text">{{ question.text }}</p>
</template>

<script lang="ts">
import { QuestionPropMixin } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'
import DynamicImage from '@/components/ui/hoc/DynamicImage.vue'

export default defineComponent({
	mixins: [QuestionPropMixin],
	components: {
		DynamicImage
	}
})
</script>

<style scoped>

</style>
